/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrokerConfigItem
 */
export interface BrokerConfigItem {
    /**
     * 
     * @type {string}
     * @memberof BrokerConfigItem
     */
    value?: string;
}

export function BrokerConfigItemFromJSON(json: any): BrokerConfigItem {
    return BrokerConfigItemFromJSONTyped(json, false);
}

export function BrokerConfigItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerConfigItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function BrokerConfigItemToJSON(value?: BrokerConfigItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

